if (!customElements.get('hero-banner')) {
  customElements.define(
    'hero-banner', 
    class HeroBanner extends HTMLElement {
      constructor() {
        super();
        this.slider =  this.querySelector('[id^="Slider-"]');
        this.next = this.querySelector('[id^="Next-"]');
        this.prev = this.querySelector('[id^="Prev-"]');
        if (!this.slider) return;
        this.initSlider();
      }
      initSlider() {
        this.swiper = new Swiper(this.slider , {
          slidesPerView: 1,
          draggable: true,
          effect: 'fade',
          grabCursor: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          loop: true, 
          speed: 1000,   
          navigation: {
            nextEl: this.next,
            prevEl: this.prev,
          }
        });
      }
    }
  )
}